import moment from 'moment';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { DateFormatWithHours } from '../../../../utilities/constants';

interface PropsFromParent {
  data: LineData[];
  minDate?: Date;
  maxDate?: Date;
  scaleLabelY?: string;
  scaleY?: string;
  scaleLabelRainY?: string;
  scaleYRain?: string;
  scaleLabelX?: string;
  suggestedMaxYValue?: number;
  suggestedMinYValue?: number;
  suggestedMaxYRainValue?: number;
}

export interface LineData {
  colorTheme: string;
  name?: string;
  data: {t?: Date; x?: number; y: number}[];
  rainData?: {t?: Date; x?: number; y: number}[];
}

interface State {}

export class LineChart extends React.PureComponent<PropsFromParent, State> {
  public componentDidCatch(error: any, info: any) {
    console.error(error, info);

    // This is a hack to fix CharJS throwing an error: TypeError: Cannot read property '_meta' of undefined
    window.location.reload();
  }

  public render() {
    const data = this.getData();
    const options = this.getOptions();

    return <Bar options={options} data={data} />;
  }

  private getOptions = () => {
    return {
      legend: {
        display: false,
      },

      hover: {mode: null},

      tooltips: {
        mode: 'x',
        callbacks: {
          title: (tooltipItem: any, data: any) => {
            let item = tooltipItem.find((a: any) => a.label !== 'values');
            if (
              item &&
              this.props.data &&
              this.props.data[item.datasetIndex] &&
              this.props.data[item.datasetIndex].data[item.index]
            ) {
              let lineItem = this.props.data[item.datasetIndex].data[item.index];
              if (lineItem.t) {
                return moment(lineItem.t.toISOString()).format(DateFormatWithHours);
              } else if (lineItem.x) {
                return lineItem.x.toString();
              }
            }

            return '';
          },

          label: (tooltipItem: any, data: any) => {
            let label = data.datasets[tooltipItem.datasetIndex].label || '';

            if (label) {
              label += ': ';
            }
            label += Math.round(tooltipItem.yLabel * 100) / 100;
            if (data.datasets[tooltipItem.datasetIndex].yAxisID === 'yRainValues') {
              label += ' ' + this.props.scaleYRain;
              return label;
            } else {
              label += ' ' + this.props.scaleY;
              return label;
            }
          },
        },
      },

      animation: {
        duration: 0, // general animation time
      },
      responsive: true,
      maintainAspectRatio: true,
      scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true,
        },
        xAxes: [
          {
            type: 'time',
            ticks: {
              min: this.props.minDate,
              max: this.props.maxDate,
            },
            time: {
              unit: 'day',
              displayFormats: {
                day: 'DD-MM',
              },
            },
            scaleLabel: {
              display: this.props.scaleLabelX ? true : false,
              labelString: this.props.scaleLabelX,
            },
          },
        ],

        yAxes: [
          // {
          //   display: false,
          //   gridLines: {
          //     display: false,
          //   },
          // },
          {
            position: 'left',
            id: 'yValues',
            ticks: {
              min: this.props.suggestedMinYValue ? this.props.suggestedMinYValue : 0,
              suggestedMax: this.props.suggestedMaxYValue ? this.props.suggestedMaxYValue : 10,
            },
            scaleLabel: {
              display: this.props.scaleLabelY ? true : false,
              labelString: this.props.scaleLabelY,
            },
          },
          {
            position: 'right',
            id: 'yRainValues',
            ticks: {
              min: this.props.suggestedMinYValue ? this.props.suggestedMinYValue : 0,
              suggestedMax: this.props.suggestedMaxYValue ? this.props.suggestedMaxYRainValue : 5,
            },
            scaleLabel: {
              display: this.props.scaleLabelRainY ? true : false,
              labelString: this.props.scaleLabelRainY,
            },
            gridLines: {
              display: false,
            },
          },
        ],
      },
    };
  };

  private deviceData = () => {
    let data = {
      labels: ['values'],
      datasets: this.props.data.map((ld, index) => {
        return {
          yAxisID: 'yValues',
          label: ld.name ? ld.name : 'line' + index,
          fill: false,
          type: 'line',
          borderWidth: 2,
          backgroundColor: ld.colorTheme,
          borderColor: ld.colorTheme,
          pointBorderColor: ld.colorTheme,
          pointBackgroundColor: ld.colorTheme,
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: ld.colorTheme,
          pointHoverBorderColor: ld.colorTheme,
          pointHoverBorderWidth: 3,
          pointRadius: 3,
          pointHitRadius: 3,
          lineTension: 0,
          data: ld.data,
        };
      }),
    };
    return data;
  };

  private getRainData = () => {
    if (this.props.data) {
      let rainDataArray = [] as any;

      this.props.data.forEach((ld, index) => {
        if (ld.rainData) {
          let rainDataObj = {
            yAxisID: 'yRainValues',
            label: ld.name ? ld.name : 'line' + index,
            fill: false,
            type: 'bar',
            borderWidth: 2,
            backgroundColor: ld.colorTheme,
            borderColor: ld.colorTheme,
            pointBorderColor: ld.colorTheme,
            pointBackgroundColor: ld.colorTheme,
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: ld.colorTheme,
            pointHoverBorderColor: ld.colorTheme,
            pointHoverBorderWidth: 3,
            pointRadius: 3,
            pointHitRadius: 3,
            lineTension: 0,
            data: ld.rainData,
          };
          rainDataArray.push(rainDataObj);
        }
      });
      return rainDataArray;
    }
  };

  private getData = () => {
    let deviceData = this.deviceData();
    let rainData = this.getRainData();

    if (rainData) {
      let dataSamlet = deviceData.datasets.concat(rainData);
      deviceData.datasets = dataSamlet;
    }

    return deviceData;
  };
}
